import { useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { useGlobalContext } from '../context'
import Question from '../Components/Question'

export const Play = () => {
    const {loading, setLoading} = useGlobalContext()
    const {questions, setQuestions } = useGlobalContext();
    const { id } = useParams()
    var url = `https://opentdb.com/api.php?${id}`
    useEffect(() => {
        fetchData();
    }, [])

    const fetchData = async () => {
        const res = await fetch(url);
        const data = await res.json();
        let newQuestions = data.results.map(element => {
            let { category,difficulty, question, correct_answer, incorrect_answers } = element
            return {
                category: category,
                difficulty: difficulty,
                question: question,
                answer: correct_answer,
                choices: incorrect_answers
            }
        })
        setQuestions(newQuestions);
        setLoading(false);
        
    }

    if (loading) {
        return <div className='mr-auto ml-auto bg-loading mt-5 loading'></div>
        
            
    } else {
        return (
            <div className='question-holder mr-auto ml-auto container pt-2'>
                <Question questions={questions}></Question>
            </div>
        )
        
    }
}

export default Play